module.exports = __webpack_public_path__ + "static/media/stem-labs.876beeb7.png";